<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <!-- <b-card>
        <div slot="header">User Profile</div>-->
        <b-form @submit.prevent="save">
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Template Name</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred:
                        $v.emailtemplate.boost_link_edit.TemplateName.$error
                    }"
                    v-model="emailtemplate.boost_link_edit.TemplateName"
                    placeholder="Required"
                    type="text"
                    id="TemplateName"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="
                      $v.emailtemplate.boost_link_edit.TemplateName.$touch()
                    "
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Subject Line</b-input-group-text
                    >
                  </b-input-group-prepend>
                  <b-form-input
                    :class="{
                      testred:
                        $v.emailtemplate.boost_link_edit.TemplateSubject.$error
                    }"
                    v-model="emailtemplate.boost_link_edit.TemplateSubject"
                    placeholder="Required"
                    type="text"
                    id="TemplateSubject"
                    autocomplete="off"
                    v-on:change.native="addDirtyField"
                    @input="
                      $v.emailtemplate.boost_link_edit.TemplateSubject.$touch()
                    "
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-input-group>
                  <!-- <b-input-group-prepend>
                    <b-input-group-text class="standardizedWidth"
                      >Html</b-input-group-text
                    >
                  </b-input-group-prepend> -->
                  <b-form-textarea
                    :class="{
                      testred:
                        $v.emailtemplate.boost_link_edit.TemplateEmailBody
                          .$error
                    }"
                    v-model="emailtemplate.boost_link_edit.TemplateEmailBody"
                    placeholder="Required"
                    autocomplete="off"
                    id="TemplateEmailBody"
                    rows="20"
                    @input="
                      $v.emailtemplate.boost_link_edit.TemplateEmailBody.$touch()
                    "
                    v-on:change.native="addDirtyField"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="false">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <a v-b-toggle.collapse2 style="cursor:pointer;">
                    <i
                      class="fa fa-caret-down fa-lg mr-2"
                      v-if="seen"
                      @click="toggleVisibility"
                    />
                    <i
                      class="fa fa-caret-up fa-lg mr-2"
                      v-if="!seen"
                      @click="toggleVisibility"
                    />
                    <span v-if="seen" @click="toggleVisibility">More</span>
                    <span v-if="!seen" @click="toggleVisibility">Less</span>
                  </a>
                </div>
                <b-collapse id="collapse2" class="mt-2">
                  <b-tabs>
                    <b-tab active>
                      <template slot="title">
                        <i class="fa fa-id-badge"></i>
                        <span class="ml-1">Employee Information</span>
                      </template>
                      <br />
                      <EmployeeCard />
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-lock"></i>
                        <span class="ml-1">Permissions</span>
                      </template>
                      <br />
                      <b-list-group>
                        <!-- <ContactRow
                          v-for="contact in client.client_edit.Contacts"
                          :key="contact.ContactID"
                          :contact="contact"
                        />-->
                        <b-list-group-item
                          >Another area to quickly setup a users
                          permissions</b-list-group-item
                        >
                      </b-list-group>
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-table"></i>
                        <span class="ml-1">Statistics</span>
                      </template>
                      <br />ADD: Billable hours versus hours worked,
                      productivity, etc... discuss
                    </b-tab>
                    <b-tab>
                      <template slot="title">
                        <i class="fa fa-bar-chart"></i>
                        <span class="ml-1">Reports</span>
                      </template>
                      <br />ADD: Employee specific reports TBD
                    </b-tab>
                  </b-tabs>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <div class="form-group form-actions" style="float:left;">
            <!-- <b-button
              v-if="
                emailtemplate.boost_link_edit.UserProfileID != -1 &&
                  emailtemplate.boost_link_edit.UserGroupID !== 2
              "
              class="mr-2 mt-2"
              style="color: white;"
              size="md"
              variant="green active"
              @click="DashRouteTo('/points/ledger')"
            >
              <i class="fa fa-dollar"></i>
              Reward Points</b-button
            > -->
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-button
              class="mr-2 mt-2"
              size="md"
              variant="outline-primary"
              @click="back"
            >
              <!-- <i class="fa fa-close"></i> -->
              Cancel
            </b-button>
            <b-button
              class="mr-0 mt-2"
              size="md"
              variant="primary"
              type="submit"
              :disabled="isClean"
            >
              <i class="fa fa-save"></i>
              Save
            </b-button>
          </div>
          <div class="form-group form-actions" style="float:right;">
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismissCountDown"
              fade
              variant="light"
              :dismissed="(dismissCountdown = 0)"
              @dismiss-count-down="countDownChanged"
            >
              Your information has been saved
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss2CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss2Countdown = 0)"
              @dismiss-count-down="countDown2Changed"
            >
              Your information could not be saved. Check all fields carefully.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
            <b-alert
              class="btn mr-4 mt-2"
              :show="dismiss3CountDown"
              fade
              variant="danger"
              :dismissed="(dismiss3Countdown = 0)"
              @dismiss-count-down="countDown3Changed"
            >
              Template name already exists! Your information could not be saved.
              <!-- <b-progress variant="info" :max="dismissSecs" :value="dismissCountDown" height="4px"></b-progress> -->
            </b-alert>
          </div>
        </b-form>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EmployeeCard from "@/components/cards/EmployeeCard.vue";
import { required, email, minLength, helpers } from "vuelidate/lib/validators";
import { CoolSelect } from "vue-cool-select";
const alpha = helpers.regex("alpha", /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/);
export default {
  name: "EmailTemplateBoostProfile",
  data() {
    return {
      selected: [], // Must be an array reference!
      dirtyFields: [],
      show: true,
      seen: true,
      isSaving: false,
      isSaved: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismiss2Secs: 3,
      dismiss2CountDown: 0,
      dismiss3Secs: 3,
      dismiss3CountDown: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    toggleVisibility() {
      this.seen = !this.seen;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    countDown2Changed(dismiss2CountDown) {
      this.dismiss2CountDown = dismiss2CountDown;
    },
    countDown3Changed(dismiss3CountDown) {
      this.dismiss3CountDown = dismiss3CountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },

    async save() {
      if (
        this.$store.state.emailtemplate.boost_links.find(
          link =>
            link.EmailTemplateBoostID !==
              this.$store.state.emailtemplate.boost_link_edit
                .EmailTemplateBoostID &&
            link.TemplateName.toLowerCase() ===
              this.$store.state.emailtemplate.boost_link_edit.TemplateName.toLowerCase()
        )
      ) {
        this.dismiss3CountDown = this.dismiss3Secs;
        return;
      }

      //double check the database
      //   if (this.$store.state.emailtemplate.boost_link_edit.UserProfileID === -1) {
      //     var _existing_id = -1;

      //     await this.$store
      //       .dispatch(
      //         "dealer/doesDealerExist",
      //         this.$store.state.emailtemplate.boost_link_edit.dealership_name
      //       )
      //       .then(response => {
      //         _existing_id = response.data["DoesDealerExistResult"];
      //       });

      //     if (_existing_id > -1) {
      //       this.dismiss3CountDown = this.dismiss3Secs;
      //       return;
      //     }
      //   }

      this.$v.$touch();
      if (this.$v.$error) {
        this.dismiss2CountDown = this.dismiss2Secs;
      } else {
        this.addDirtyFieldManual(
          "dealership_id",
          this.$store.state.dealer.dealer_edit.dealership_id
        );
        this.$store.state.saveOp.localUrl = "/Template/SaveBoost/";
        this.$store.state.saveOp.localVariableName = "_bl";
        this.$store.state.saveOp.localVariableObject = this.$store.state.emailtemplate.boost_link_edit;
        this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
        this.$store.state.saveOp.localFieldToSet = "EmailTemplateBoostID";
        this.$store.state.saveOp.localReturnObject = "SaveBoostResult";

        this.$store
          .dispatch("saveOp/BuildSaveOperation")
          .then(
            this.$store
              .dispatch("saveOp/EmitSave")
              .then(
                (this.dirtyFields = []),
                (this.dismissCountDown = this.dismissSecs),
                this.$store.state.saveOp.DestroySaveOperation
              )
          );

        // this.$store
        //   .dispatch("saveOp/BuildSaveOperation")
        //   .then(this.$store.dispatch.dispatch("saveOp/EmitSave"))
        //   .then(
        //     (this.dirtyFields = [])((this.dismissCountDown = this.dismissSecs))
        //   );
      }
    },
    addDirtyField: function(event) {
      if (event.which !== 9 && event.which !== 13) {
        this.dirtyFields = this.dirtyFields.filter(
          dirtyField => dirtyField.FieldName !== event.target.id
        );
        this.dirtyFields.push({
          FieldName: event.target.id,
          FieldValue: event.target.value
        });
      }
    },
    addDirtyFieldManual: function(_name, _value) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== _name
      );
      this.dirtyFields.push({
        FieldName: _name,
        FieldValue: _value
      });
    },
    addDirtyFieldWatch: function(field, newValue) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== field
      );
      this.dirtyFields.push({
        FieldName: field,
        FieldValue: newValue
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    addDirtyFieldRadio: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== "IsSU"
      );
      this.dirtyFields.push({
        FieldName: "IsSU",
        FieldValue: event.target.value
      });
    },
    addDirtyFieldSwitch: function(event) {
      this.dirtyFields = this.dirtyFields.filter(
        dirtyField => dirtyField.FieldName !== event.target.id
      );
      this.dirtyFields.push({
        FieldName: event.target.id,
        FieldValue: event.target.checked.toString()
      });
      this.$store.state.saveOp.localDirtyFields = this.dirtyFields;
    },
    DashRouteTo(_page) {
      this.save();
      this.$router.push(_page);
    }
  },
  computed: {
    ...mapState(["emailtemplate", "saveOp"]),
    ...mapActions("saveOp", ["Save", "EmitSave"]),
    isClean() {
      return this.dirtyFields.length === 0;
    }
  },
  components: {
    EmployeeCard,
    CoolSelect
  },
  validations: {
    emailtemplate: {
      boost_link_edit: {
        TemplateName: {
          required
        },
        TemplateEmailBody: {
          required
        },
        TemplateSubject: {
          required
        }
      }
    }
  },
  watch: {}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.input-group-text {
  color: #111;
}
.testred {
  color: red;
  border-color: red;
}
</style>
